module.exports = __webpack_public_path__ + "img/Logo.4fd660f8.png";